import Vue from "vue";
import Vuex from "vuex";
Vue.use(Vuex);

const reportingModalStore = new Vuex.Store({
	state: {
		modalParams: {},
		modalDismissAction: null,
		activeModal: null
	},

	mutations: {
		deactivateModal: function(state) {
			state.activeModal = null;
			if (state.modalDismissAction) {
				state.modalDismissAction();
				state.modalDismissAction = null;
			}
		},

		reportCadfile: function (state, cadfile_id) {
			state.modalParams = {
				reportableId: cadfile_id,
				reportable: 'cadfile_id',
				title: 'Report model',
				reasons: ['Spam', 'Violates Community Guidelines', 'Copied from my model']
			};
			state.activeModal = 'report-modal';
		},

		reportComment: function (state, { id, cb }) {
			state.modalParams = {
				reportableId: id,
				reportable: 'comment_id',
				title: 'Report comment',
				reasons: ['Spam', 'Violates Community Guidelines']
			};
			state.activeModal = 'report-modal';
			state.modalDismissAction = cb;
		},
	},
	actions: {}
});

Grabcad = Grabcad || {};
Grabcad.reportingModalStore = reportingModalStore;

export default reportingModalStore;
